<template>
  <div id="project-subscribe-with-token">
    <div class="ui hidden section divider" />
    <div :class="['ui icon message', error ? 'negative' : message ? 'positive' : 'info']">
      <i :class="['notched', loading ? 'circle loading' : error ? 'times' : 'green check' , 'icon']" />
      <div class="content">
        <div class="header">
          {{ message || 'Vérification de votre abonnement' }}
        </div>
      </div>
    </div>
    <div class="ui hidden section divider" />
    <a
      v-if="projectUrl"
      :href="projectUrl"
      class="ui right labeled icon positive button"
    >
      <i class="right arrow icon" />
      Accéder au projet
    </a>
  </div>
</template>

<script>
import projectAPI from '@/services/project-api';

export default {
  name: 'ProjectSubcribeWithToken',

  data() {
    return {
      error: null,
      loading: false,
      message: null,
      projectUrl: null,
    };
  },

  created() {
    this.subscribeProject();
  },

  methods: {
    async subscribeProject() {
      // Récupérer le token dans les params de la route
      const token = this.$route.query.token;
      // Fetch l'API pour abonner l'utilisateur avec le token dans l'url
      try {
        const baseUrl = this.$store.state.configuration.VUE_APP_DJANGO_API_BASE;
        // Attendre la réponse de la promesse avec une fonction async
        const response = await projectAPI.subscribeProjectWithToken(baseUrl, token);
        // Si le statut de la réponse est en succès, afficher le message reçu, sinon message générique
        this.message = response?.data?.detail || 'Vous êtes abonné.';
        // Récupérer l'url du projet pour afficher dans un bouton
        this.projectUrl = response?.data?.project_url;
      } catch (err) {
        if (err.response?.status === 400 || err.response?.status === 403) {
          // Message backend, sinon message générique
          this.message = err.response?.data?.detail || 'Une erreur est survenue lors de la validation de votre abonnement.';
          // Stockage de l'erreur pour adapter le style du message 
          this.error = err;
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
